import {makeAutoObservable} from 'mobx';

import type {TimeslotModel} from './Timeslot.model';
import type {Coach, DataModel, MarkedDates} from './types';

import {dateTimeObjToTimestamp} from '../../utils/datetime';
import {getFileSrc} from '../../utils/entity/file';
import {ZERO_COACH_SCHEDULE} from './utils/constants';

export class CoachModel implements DataModel {
  entity: Coach;
  isBookButtonDisabled = false;

  constructor(coach: Coach) {
    this.entity = coach;

    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  get availableConferences() {
    return null;
  }

  get avatarUrl() {
    return getFileSrc(this.entity.avatar).url;
  }

  get bookingRange() {
    if (this.entity.coach_schedule_until) {
      return {
        end: dateTimeObjToTimestamp(this.entity.coach_schedule_until),
      };
    } else {
      throw new Error('no range error');
    }
  }

  get conferenceCount() {
    return 0;
  }

  get conferenceDuration() {
    return this.entity.coach_intro_call_length ?? null;
  }

  get id() {
    return this.entity._id as string;
  }

  get name() {
    return this.entity.name;
  }

  get schedule() {
    return this.entity.coach_schedule || ZERO_COACH_SCHEDULE;
  }

  get shouldShowBookButton() {
    return Boolean(this.entity.coach_intro_call_length);
  }

  /**
   * for DataModel
   */
  get title() {
    return this.name;
  }

  getMarkedDates(timeslots: Map<string, TimeslotModel[][]>): MarkedDates {
    return {
      available: new Map(Array.from(timeslots.keys()).map(date => [date, {}])),
      unavailable: new Map(),
    };
  }
}
